import { loc } from "../i18n/survey";

enum TimeAvailable {
  ThirtyMinutes = '30OrLess',
  FourtyFiveMinutes = '45',
  SixtyMinutes = '60',
  NinetyMinutes = '90',
}

const timeAvailableQuestion = {
  name: "timeAvailable",
  title: loc("quiz.timeAvailable.title"),
  description: loc("quiz.timeAvailable.description"),
  descriptionLocation: "underTitle",
  type: "radiogroup",
  choices: [
    {
      value: TimeAvailable.ThirtyMinutes,
      text: loc("quiz.timeAvailable.choices.thirty"),
      enableIf: "{numberWorkouts} != '2' and {numberWorkouts} != 'As many as possible'",
    },

    {
      value: TimeAvailable.SixtyMinutes,
      text: loc("quiz.timeAvailable.choices.sixty"),
    },
  ],
  isRequired: true,
};

export { TimeAvailable, timeAvailableQuestion };
